<template>
  <div class="signature-wrapper">
    <!-- using vue bootstrap alert -->
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
    >
      {{allertMessage}}
    </b-alert>
    <vueSignature ref="signature" :sigOption="option" :w="'100%'" :h="'100vh'"></vueSignature>
    <div class="buttons-wrapper">
      <p>Please leave your signature</p>
      <base-button @click="back" type="primary" class="my-2">Back</base-button>
      <base-button @click="clear" type="primary" class="my-2">Clear</base-button>
      <base-button @click="save" type="primary" class="my-2">Save</base-button>
    </div>
  </div>
</template>

<script>
import alertMixin from './../views/mixins/alertMixin'
export default {
  data () {
    return {
      signatures: [],
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'rgb(255,255,255)'
      }
    }
  },
  props: {
    signaturesList: {
      type: Array,
      description: 'Using to connect signature to some variable'
    }
  },
  methods: {
    save () {
      if (this.signatures.length < 3) {
        let self = this
        let jpeg = self.$refs.signature.save('image/jpeg', 0.5)

        let id = '_' + Math.random().toString(36).substr(2, 9)
        this.$db.signatures.add({
          id: id,
          canvas: jpeg
        })
          .then(() => {
            this.signatures.push(id)
            this.showAlert(2, 'Signature has been saved')
            this.clear()
          })
          .catch(err => {
            this.showAlert(2, 'Problem with signature saving')
            this.clear()
            console.log(err)
          })
      } else {
        this.showAlert(2, 'Max signatures quantity is 3 ')
        this.clear()
      }
    },
    back () {
      this.$emit('closesignature', [this.signatures, this.signaturesList])
    },
    clear () {
      this.$refs.signature.clear()
    }
  },
  destroyed () {
    let body = document.body
    body.classList.remove('overflowbody')
  },
  mixins: [alertMixin]
}
</script>
<style scoped>
 .signature-wrapper {
   position: fixed;
   top: 0;
   bottom: 0;
   left: 0;
   right: 0;
   z-index: 2;
 }
 .signature-wrapper .buttons-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }
  .buttons-wrapper p {
    margin-bottom: 0;
  }
</style>
